<script setup>
import { computed } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import wootConstants from 'dashboard/constants/globals';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeTab: {
    type: String,
    default: wootConstants.ASSIGNEE_TYPE.ME,
  },
});

const emit = defineEmits(['chatTabChange']);

const activeTabIndex = computed(() => {
  return props.items.findIndex(item => item.key === props.activeTab);
});

const onTabChange = selectedTabIndex => {
  if (selectedTabIndex >= 0 && selectedTabIndex < props.items.length) {
    const selectedItem = props.items[selectedTabIndex];
    if (selectedItem.key !== props.activeTab) {
      emit('chatTabChange', selectedItem.key);
    }
  }
};

const keyboardEvents = {
  'Alt+KeyN': {
    action: () => {
      if (props.activeTab === wootConstants.ASSIGNEE_TYPE.ALL) {
        onTabChange(0);
      } else {
        const nextIndex = (activeTabIndex.value + 1) % props.items.length;
        onTabChange(nextIndex);
      }
    },
  },
};

useKeyboardEvents(keyboardEvents);
</script>

<template>
  <div
    class="grid h-[3.25rem] grid-cols-3 items-center gap-1 border-b border-n-weak bg-n-solid-1 px-3 py-2"
    role="tablist"
  >
    <button
      v-for="(item, index) in items"
      :key="item.key"
      type="button"
      role="tab"
      :aria-selected="index === activeTabIndex"
      class="reset-base m-0 inline-flex h-9 min-h-9 min-w-0 self-center items-center justify-center gap-1.5 rounded-xl px-2 py-0 text-xs font-semibold leading-none transition-all !translate-y-0"
      :class="
        index === activeTabIndex
          ? 'bg-n-brand text-white shadow-sm shadow-n-brand/20'
          : 'text-n-slate-10 hover:bg-n-alpha-2 hover:text-n-slate-12'
      "
      @click="onTabChange(index)"
    >
      <span class="truncate">{{ item.name }}</span>
      <span
        class="grid h-5 min-w-5 place-items-center rounded-full px-1 text-[10px]"
        :class="
          index === activeTabIndex
            ? 'bg-white/20 text-white'
            : 'bg-n-slate-4 text-n-slate-11'
        "
      >
        {{ item.count }}
      </span>
    </button>
  </div>
</template>
